import React, { useState } from "react";
import styles from "../../../views/ReportView/ReportView.module.css";
import IconAnimation from "../../iconAnimation/iconAnimation";
import NotReportViewData from "../../NotReportViewData/NotReportView";
import { GiRelationshipBounds } from "react-icons/gi";

const RelationshipWithMutual = ({ data }) => {
  const [user, setUser] = useState(data);
  const [isEditing] = useState(false);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setUser({ ...user, [name]: value });
  };

  return (
    <div className={styles.informacionPolitica} id="relacion">
      <div className={styles.sectionTitle2}>
        <h2 className={styles.sectionTitleH2}>Relación con la Mutual</h2>
        <IconAnimation />
      </div>
      {!user || !user.RelationshipWithMutual ? (
        <NotReportViewData
          title="Relación con la mutual"
          Icon={GiRelationshipBounds}
        />
      ) : (
        <>
          <label className={styles.inputLabel}>
            Relación:
            <select
              className={styles.inputField}
              name="relation"
              value={user.RelationshipWithMutual.relation}
              disabled={!isEditing}
            >
              <option value="Socio">Socio</option>
              <option value="Proveedor">Proveedor</option>
              <option value="Fondista">Fondista</option>
            </select>
          </label>
          <label className={styles.inputLabel}>
            Canal:
            <input
              className={styles.inputField}
              name="canal"
              value={user.RelationshipWithMutual.canal}
              disabled={!isEditing}
            />
          </label>
          {user.RelationshipWithMutual.relation === "Socio" && (
            <>
              <label className={styles.inputLabel}>
                Fecha de crédito:
                <input
                  className={styles.inputField}
                  type="date"
                  name="creditDate"
                  value={user.RelationshipWithMutual.creditDate || ""}
                  onChange={handleInputChange}
                  readOnly={!isEditing}
                />
              </label>
              <label className={styles.inputLabel}>
                Tipo de crédito:
                <select
                  className={styles.inputField}
                  name="typeOfCredit"
                  value={
                    user.RelationshipWithMutual.typeOfCredit ||
                    "Crédito de consumo"
                  }
                  onChange={handleInputChange}
                  disabled={!isEditing}
                >
                  <option value="Crédito de consumo">Crédito de consumo</option>
                </select>
              </label>
              <label className={styles.inputLabel}>
                Monto de crédito:
                <input
                  className={styles.inputField}
                  type="number"
                  name="amountOfCredit"
                  value={user.RelationshipWithMutual.amountOfCredit || ""}
                  onChange={handleInputChange}
                  readOnly={!isEditing}
                />
              </label>
              <label className={styles.inputLabel}>
                Cantidad de cuotas:
                <input
                  className={styles.inputField}
                  type="number"
                  name="amountOfFees"
                  value={user.RelationshipWithMutual.amountOfFees || ""}
                  onChange={handleInputChange}
                  readOnly={!isEditing}
                />
              </label>
              <label className={styles.inputLabel}>
                Monto de la cuota:
                <input
                  className={styles.inputField}
                  type="number"
                  name="installmentAmount"
                  value={user.RelationshipWithMutual.installmentAmount || ""}
                  onChange={handleInputChange}
                  readOnly={!isEditing}
                />
              </label>
              <label className={styles.inputLabel}>
                Entidad de Prestamo:
                <input
                  className={styles.inputField}
                  type="text"
                  name="loanBank"
                  value={user.RelationshipWithMutual.loanBank || ""}
                  onChange={handleInputChange}
                  readOnly={!isEditing}
                />
              </label>
              <label className={styles.inputLabel}>
                Afiliado:
                <input
                  className={styles.inputField}
                  type="text"
                  name="affiliate"
                  value={user.RelationshipWithMutual.affiliate || ""}
                  onChange={handleInputChange}
                  readOnly={!isEditing}
                />
              </label>
              <label className={styles.inputLabel}>
                Crédito:
                <input
                  className={styles.inputField}
                  type="text"
                  name="credit"
                  value={user.RelationshipWithMutual.credit || ""}
                  onChange={handleInputChange}
                  readOnly={!isEditing}
                />
              </label>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default RelationshipWithMutual;
